module.exports = __webpack_public_path__ + "static/media/html-logo.9228f542.png";